export default __webpack_public_path__ + "static/media/SurveyMeasure.336ce5c1.svg";